import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'app-menu-style4',
  templateUrl: './menu-style4.component.html',
  styleUrls: ['./menu-style4.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuStyle4Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/mega-menu/menu-style4/menu-style4.component.ts